import React, { memo } from 'react';
import { Flex, Box } from '@cad-arc';
import { MAP_TOP_MENU_BAR_MARGIN_LEFT, MAP_TOP_MENU_BAR_MARGIN_TOP } from '../../esri/constants';
import { EventAndUnitSearchInput } from './event-and-unit-search-input';
import { LocationSearchInput } from './location-search-input';

interface Props {
    selectUnit: (unitId: number, shouldResetZoomLevel?: boolean) => void;
    selectEvent: (eventId: number, shouldResetZoomLevel?: boolean) => void;
    selectUnitUser: (unitUserId: number, shouldResetZoomLevel?: boolean) => void;
}
export const MapTopMenuBar = memo(
    ({ selectUnit, selectEvent, selectUnitUser }: Props): React.ReactElement => (
        <Box
            position="absolute"
            left={`${MAP_TOP_MENU_BAR_MARGIN_LEFT}px`}
            top={`${MAP_TOP_MENU_BAR_MARGIN_TOP}px`}
            zIndex={1}
            width={608}
            backgroundColor="surface.foreground"
            padding="12px"
            borderRightWidth="1px"
            borderBottomWidth="1px"
            borderStyle="solid"
            borderColor="border.default"
            borderBottomEndRadius="8px"
        >
            <Flex gap={2}>
                <LocationSearchInput />
                <EventAndUnitSearchInput
                    selectUnit={selectUnit}
                    selectEvent={selectEvent}
                    selectUnitUser={selectUnitUser}
                />
            </Flex>
        </Box>
    )
);
